import React from "react";
import { useB2BTranslation } from "../B2BShared/hooks/useB2BTranslation";
import B2BBackButton from "../B2BShared/B2BBackButton";
import "./B2BBrandPerceptionPage.css";

const B2BBrandPerceptionPage: React.FC = () => {
  const { tDashboard } = useB2BTranslation();

  return (
    <div className="brand-perception-page">
      <div className="perception-header">
        <B2BBackButton
          to="/gcb"
          translationKey="brandPerception.backToB2B"
          variant="orange"
          size="medium"
          namespace="b2b"
        />
        <h1>{tDashboard("brandPerception.title")}</h1>
        <p>{tDashboard("brandPerception.description")}</p>
      </div>

      {/* Empty Content */}
      <div className="empty-content">
        <p>Content has been removed.</p>
      </div>
    </div>
  );
};

export default B2BBrandPerceptionPage;

